import { IDB } from "../../../core/common/businesslogic/index";
import { ISettingPage } from "../../../core/common/businesslogic/index";
import { ml } from "../../../core/common/matrixlib";
import { IValidationSpec, JsonEditor } from "../../../core/common/UI/JsonEditor";
import { app, globalMatrix, restConnection } from "../../../core/globals";
import {
    XRUserType,
    XRGroupType,
    XRGroupPermissionType,
    XRGetUser_AllUsers_GetUserListAck,
    XRGetGroup_AllGroups_GetGroupListAck,
} from "../../../core/RestResult";
import { IConfigApp } from "./IConfigApp";

export interface IConfigPage {
    getNode(): IDB;
    saveAsync(): JQueryDeferred<unknown>;
    load(pageId: string): void;
    getProject(): string;
    getCategory(): string;
    getField(): string;
    willUnload(): void;
}

export interface IGroupsUsers {
    users: XRUserType[];
    groups: XRGroupType[];
}

export class ConfigPage implements IConfigPage {
    static PROJECT_SETTING_FOLDER_BASE_ID: string = "projectsettings";
    public static PROJECT_SETTING_FOLDER_TYPE: string = "ProjectSettingsFolder";

    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    protected pageId: string;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    protected simple: JQuery;

    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    protected allUsers: XRUserType[];
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    protected allGroups: XRGroupType[];
    configApp: IConfigApp;

    getNode(): IDB {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    saveAsync(): JQueryDeferred<unknown> {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    load(pageId: string): void {
        this.pageId = pageId;
    }

    constructor(configApp: IConfigApp) {
        this.configApp = configApp;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getProject() {
        return this.pageId.split("-")[0];
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getCategory() {
        return this.pageId.split("-")[1];
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getField() {
        return this.pageId.split("-")[2];
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    willUnload(): void {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected initPage(
        title: string,
        showAdvancedBtn: boolean,
        showDeleteText: string | null,
        help: string,
        externalHelp?: string,
        showCopy?: boolean,
    ) {
        app.itemForm.html("");
        let top = $("<div id='top'>").appendTo(app.itemForm);
        top.append(ml.UI.getPageTitle(title));
        let toolBarButtons = $(".toolbarButtons", top);
        toolBarButtons.removeClass("btn-group");

        if (showAdvancedBtn) {
            $('<button data-cy="advanced" class="btn btn-link btn-top">advanced</button>')
                .click((event: JQueryEventObject) => {
                    this.showAdvanced();
                })
                .appendTo(toolBarButtons);
        }

        if (showDeleteText) {
            $('<button data-cy="delete" class="btn btn-link btn-top"><i class="fal fa-trash-alt"/></button>')
                .click((event: JQueryEventObject) => {
                    ml.UI.showConfirm(
                        -100,
                        { title: showDeleteText, ok: "delete", nok: "cancel" },
                        () => {
                            this.doDelete();
                        },
                        () => {},
                    );
                })
                .appendTo(toolBarButtons);
        }

        if (showCopy) {
            $('<button data-cy="copy" class="btn btn-link btn-top"><i class="fal fa-copy"/></button>')
                .click((event: JQueryEventObject) => {
                    this.doCopy();
                })
                .appendTo(toolBarButtons);
        }

        if (externalHelp) {
            $('<button data-cy="eternalHelp" class="btn btn-link btn-top"><i class="fal fa-question-circle"/></button>')
                .click((event: JQueryEventObject) => {
                    window.open("https://urlshort.matrixreq.com/d25/" + externalHelp);
                })
                .appendTo(toolBarButtons);
        }

        $("<div class='inlineHelp'>").appendTo(top).html(help);

        this.simple = $("<div id='simple'>").appendTo(app.itemForm);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showAdvanced(): void {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected doCopy(): void {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected doDelete(): void {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showSimple(): void {}

    protected showWarning(text: string, id?: string): JQuery {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (id == undefined) {
            id = "noId";
        }

        let ret = $(`<div class='configWarning' id='${id}'>`);
        ret.append(`<div><i class="fa fa-exclamation-triangle"></i> Caution </div>`);
        ret.append(`<div class="info">${text}</div>`);

        ret.appendTo(this.simple);

        return ret;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showNote(text: string) {
        let ret = $(`<div class='configNote' >`);
        ret.append(`<div><i class="fa fa-info-circle"></i> Information </div>`);
        ret.append(`<div class="info">${text}</div>`);

        ret.appendTo(this.simple);

        return ret;

        $("<div class='configNote'>")
            .html("<span class='fal fa-info-circle'></span>  " + text)
            .appendTo(this.simple);
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showAdvancedCode(code: string, success: (code: string) => void, semanticValidate?: IValidationSpec) {
        let that = this;

        let je = new JsonEditor();
        je.showDialog(
            "Advanced Edit",
            code,
            function (newValue: string) {
                success(newValue);
            },
            semanticValidate,
        );
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getProjectSettingLink(setting: string) {
        return (
            globalMatrix.matrixBaseUrl +
            "/adminConfig/" +
            this.getProject() +
            "-" +
            ConfigPage.PROJECT_SETTING_FOLDER_BASE_ID +
            "-" +
            setting
        );
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getProjectSettingLinkA(setting: string, name: string) {
        return "<a href='" + this.getProjectSettingLink(setting) + "'>" + name + "</a>";
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getCategorySettingLink() {
        return (
            globalMatrix.matrixBaseUrl + "/adminConfig/" + this.getProject() + "-" + this.getCategory() + "-settings"
        );
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getTraceSettingLink() {
        return globalMatrix.matrixBaseUrl + "/adminConfig/" + this.getProject() + "-projectsettings-traceability";
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getPluginLink() {
        return globalMatrix.matrixBaseUrl + "/adminConfig/extensions";
    }

    //copy from UiTools for admin client!
    // make a unique ID of the numeric group id, this is used to be stored in fields
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getGroupId(group: XRGroupType) {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        return ml.UI.SelectUserOrGroup.getGroupId(<XRGroupPermissionType>(<any>group));
    }

    // copy from UiTools for admin client!
    // convert a group id used in mail to italic group name
    // this is used to be displayed in UI
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected getGroupDisplayNameFromId(groupOrUserId: string) {
        let that = this;

        for (let idx = 0; idx < this.allGroups.length; idx++) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (this.getGroupId(this.allGroups[idx]) == groupOrUserId) {
                let canEdit = that.configApp.canGroupWrite(that.getProject(), this.allGroups[idx].groupId);

                let groupName = canEdit
                    ? this.allGroups[idx].groupName
                    : "<span style='text-decoration:line-through'>" + this.allGroups[idx].groupName + "</span>";

                return "<span class='groupFlag'>group&nbsp;</span>" + groupName;
            }
        }
        let canEdit = that.configApp.canUserWrite(that.getProject(), groupOrUserId);
        return canEdit ? groupOrUserId : "<span style='text-decoration:line-through'>" + groupOrUserId + "</span>";
    }

    // returns the name user id - first last name
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected combinedName(user: XRUserType) {
        return globalMatrix.ItemConfig.getCombinedName(user);
    }
    // resize dialog
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private resizeUserSelectDlg(dlg: JQuery) {
        let height = dlg.height();
        let top = $(".ms-list", dlg).position().top;

        $(".ms-list", dlg).height(height - top);
    }

    // this adds an <input> control showing the selected users / user groups, when clicking it allows to change the selection in a dialog
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    public showUserAndGroupsSelectWithDialog(
        container: JQuery,
        showUsers: boolean,
        showGroups: boolean,
        help: string,
        empty: string,
        selected: string[],
        dialogTitle: string,
        onSelect: (selection: string[]) => void,
    ) {
        let that = this;
        $('<span class="baseControlHelp">' + help + "</span>").appendTo(container);
        let ctrl = $("<div class='baseControl'>").appendTo(container);
        let input = $("<div class='form-control userSelect userSelectAdmin'>").appendTo(ctrl);
        input.html(
            selected && selected.length
                ? selected
                      .map(function (userOrGroup) {
                          return that.getGroupDisplayNameFromId(userOrGroup);
                      })
                      .join(", ")
                : "<span class='emptySelection'>" + empty + "</span>",
        );
        ctrl.click(function (event: JQueryMouseEventObject) {
            that.showSelectDialog(
                selected ? selected : [],
                showUsers,
                showGroups,
                dialogTitle,
                (selection: string[]) => {
                    let selectedUI = selection.map(function (userOrGroup) {
                        return that.getGroupDisplayNameFromId(userOrGroup);
                    });
                    input.html(
                        selectedUI.length ? selectedUI.join(", ") : "<span class='emptySelection'>" + empty + "</span>",
                    );
                    selected = ml.JSON.clone(selection);
                    onSelect(selection);
                },
            );

            return false;
        });
    }

    // opens a dialog to select users
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showSelectDialog(
        selectedIn: string[],
        showUsers: boolean,
        showGroups: boolean,
        dialogTitle: string,
        onSelect: (selection: string[]) => void,
    ) {
        let that = this;

        let dlg = $("<div  data-cy='selectDialog'>").appendTo("body");
        let select = $("<select multiple>").appendTo(dlg);

        let selected: string[] = selectedIn ? ml.JSON.clone(selectedIn) : [];

        select.append("<option style='display:none' value='' data-search=''>");
        let users = showUsers ? that.allUsers : [];
        let groups = showGroups ? that.allGroups : [];

        let userSelect = select;
        let groupSelect = select;
        let groupIds = groups.map((g) => that.getGroupId(g));
        if (groups.length && users.length) {
            userSelect = $("<optgroup label='Users'>").appendTo(select);
            groupSelect = $("<optgroup label='User Groups'>").appendTo(select);
        }

        // add to user select
        $.each(users, function (userIdx, user) {
            let name = that.combinedName(user);
            let email = user.email ? user.email : "";
            let searchVal = email + " " + name;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let sel = selected.indexOf(user.login) != -1 ? " selected" : "";
            let canEdit = that.configApp.canUserWrite(that.getProject(), user.login) ? "1" : "0";

            userSelect.append(
                $(
                    `<option data-cy="${
                        user.login
                    }" data-canedit='${canEdit}' data-search='${searchVal.toLowerCase()}' title='${email}' value='${
                        user.login
                    }' ${sel} >${name}</option>`,
                ),
            );
        });

        $.each(groups, function (groupIdx, group) {
            let groupName = group.groupName;
            let groupId = that.getGroupId(group);
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let sel = selected.indexOf(groupId) != -1 ? " selected" : "";
            let canEdit = that.configApp.canGroupWrite(that.getProject(), group.groupId);
            groupSelect.append(
                $(
                    `<option data-group='group' data-canedit='${canEdit}' data-search='${groupName.toLowerCase()}' value='${groupId}' ${sel} >${groupName}</option>`,
                ),
            );
        });

        // add selected but deleted users/user groups
        let allUsers = users.map((user) => user.login);
        for (let selectedUserOrGroup of selected) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (groupIds.indexOf(selectedUserOrGroup) == -1 && allUsers.indexOf(selectedUserOrGroup) == -1) {
                let entryOfDeleted = $(
                    `<option data-canedit='0' data-search='${selectedUserOrGroup}' data-cy='${selectedUserOrGroup}' title='${selectedUserOrGroup}' value='${selectedUserOrGroup}' selected>${selectedUserOrGroup}</option>`,
                );
                if (selectedUserOrGroup.match(/g_[0-9]+_g/)) {
                    groupSelect.append(entryOfDeleted);
                } else {
                    userSelect.append(entryOfDeleted);
                }
            }
        }

        let showOnly = "groups / users";
        if (!showGroups) {
            showOnly = "users";
        }
        if (!showUsers) {
            showOnly = "groups";
        }

        dlg.dialog({
            autoOpen: true,
            title: dialogTitle ? dialogTitle : "Select",
            width: 716,
            height: 580,
            resizeStop: function () {
                that.resizeUserSelectDlg(dlg);
            },
            modal: true,
            open: function () {
                ml.UI.pushDialog(dlg);
                let showOnlyWrite =
                    '<div class="checkbox" data-cy="showOnlyWrite"  ><label><input type="checkbox" class="showOnlyWrite" checked>Show only ' +
                    showOnly +
                    " with write access</label></div>";
                let showOnlyWriteSel =
                    '<div class="checkbox" data-cy="showOnlyWriteSel"  ><label><input type="checkbox" class="showOnlyWriteSel">Show only ' +
                    showOnly +
                    " with write access</label></div>";
                select.multiSelect({
                    selectableHeader:
                        "<div class='custom-header'>" +
                        showOnlyWrite +
                        "</div><input type='text' class='form-control ms-search' autocomplete='off' placeholder='filter'>",
                    selectionHeader:
                        "<div class='custom-header'>" +
                        showOnlyWriteSel +
                        "</div><input type='text' class='form-control ms-search' autocomplete='off' placeholder='filter'>",
                    afterInit: function () {
                        // TODO: fix it
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        let wow = this,
                            $selectableSearch = wow.$selectableUl.prev(),
                            $selectionSearch = wow.$selectionUl.prev(),
                            selectableSearchString =
                                "#" + wow.$container.attr("id") + " .ms-elem-selectable:not(.ms-selected)",
                            selectionSearchString = "#" + wow.$container.attr("id") + " .ms-elem-selection.ms-selected",
                            selectionOptions = "#" + wow.$container.attr("id") + " .ms-elem-selectable",
                            selectedOptions = "#" + wow.$container.attr("id") + " .ms-elem-ms-selected",
                            selectedOptionsOff = "#" + wow.$container.attr("id") + " .ms-elem-selection";

                        that.markUsersWithoutAccess($(selectionOptions));
                        that.markUsersWithoutAccess($(selectedOptions));
                        that.markUsersWithoutAccess($(selectedOptionsOff));

                        $("li", dlg).each(function (idx, opt) {
                            if ($(opt).data("group")) {
                                $(opt).prepend("<span class='groupFlag'>group</span>");
                            }
                        });

                        $selectableSearch.on("keyup", function (e: JQueryKeyEventObject) {
                            if (e.which === 40) {
                                wow.$selectableUl.focus();
                                return false;
                            } else {
                                that.filterGroupsAndUsers(
                                    $(selectableSearchString),
                                    $selectableSearch.val().toLowerCase(),
                                    $(".showOnlyWrite").prop("checked"),
                                );
                                return true;
                            }
                        });

                        $selectionSearch.on("keyup", function (e: JQueryKeyEventObject) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (e.which == 40) {
                                wow.$selectionUl.focus();
                                return false;
                            } else {
                                let searchExpr = $selectionSearch.val().toLowerCase();

                                that.filterGroupsAndUsers(
                                    $(selectionSearchString),
                                    $selectionSearch.val().toLowerCase(),
                                    $(".showOnlyWriteSel").prop("checked"),
                                );

                                return true;
                            }
                        });

                        $(".showOnlyWrite").click(function () {
                            that.filterGroupsAndUsers(
                                $(selectableSearchString),
                                $selectableSearch.val().toLowerCase(),
                                $(".showOnlyWrite").prop("checked"),
                            );
                        });
                        $(".showOnlyWriteSel").click(function () {
                            that.filterGroupsAndUsers(
                                $(selectionSearchString),
                                $selectionSearch.val().toLowerCase(),
                                $(".showOnlyWriteSel").prop("checked"),
                            );
                        });
                        that.filterGroupsAndUsers(
                            $(selectableSearchString),
                            $selectableSearch.val().toLowerCase(),
                            $(".showOnlyWrite").prop("checked"),
                        );
                        that.filterGroupsAndUsers(
                            $(selectionSearchString),
                            $selectionSearch.val().toLowerCase(),
                            $(".showOnlyWriteSel").prop("checked"),
                        );
                    },
                    afterSelect: function (sel: string[]) {
                        selected.push(sel[0]);
                    },
                    afterDeselect: function (sel: string[]) {
                        selected = selected.filter(function (s) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            return s != sel[0];
                        });
                    },
                });

                that.resizeUserSelectDlg(dlg);
            },
            close: function () {
                ml.UI.popDialog(dlg);
                dlg.remove();
            },
            buttons: [
                {
                    text: "Ok",
                    class: "btnDoIt",
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    click: function () {
                        onSelect(selected);
                        dlg.dialog("close");
                    },
                },
                {
                    text: "Cancel",
                    class: "btnCancelIt",
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    click: function () {
                        dlg.dialog("close");
                    },
                },
            ],
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected markUsersWithoutAccess(lis: JQuery) {
        $.each(lis, function (lidx, li) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if ($(li).data("canedit") != "1") {
                $(li).css("text-decoration", "line-through");
            }
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected filterGroupsAndUsers(lis: JQuery, sex: string, writeOnly: boolean) {
        $.each(lis, function (lidx, li) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let hasSex = !sex || $(li).data("search").indexOf(sex) != -1;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let hasWrite = !writeOnly || $(li).data("canedit") == "1";
            hasSex && hasWrite ? $(li).show() : $(li).hide();
        });
    }

    // store all the current groups and users in page
    protected updateUsersAndGroups(withDetails: boolean): JQueryDeferred<void> {
        let that = this;

        let res: JQueryDeferred<void> = $.Deferred();
        restConnection.getServer("user" + (withDetails ? "?details=1" : "")).done(function (allUsersResult) {
            that.allUsers = (allUsersResult as XRGetUser_AllUsers_GetUserListAck).user
                .filter(function (user) {
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    return user.userStatus != "deleted" && user.userStatus != "blocked" && !user.superAdmin;
                })
                .sort(function (a, b) {
                    if (a.login < b.login) {
                        return -1;
                    } else {
                        return 1;
                    }
                });

            restConnection.getServer("group" + (withDetails ? "?&details=1" : "")).done(function (allGroupsResult) {
                that.allGroups = (allGroupsResult as XRGetGroup_AllGroups_GetGroupListAck).groups.sort(function (a, b) {
                    if (a.groupName.toLowerCase() < b.groupName.toLowerCase()) {
                        return -1;
                    } else {
                        return 1;
                    }
                });

                res.resolve();
            });
        });

        return res;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initMeta(users: XRUserType[], groups: XRGroupType[], pageId: string) {
        this.pageId = pageId;
        this.allGroups = groups;
        this.allUsers = users;
    }
}

export class GenericAdminPage extends ConfigPage {
    private page: ISettingPage;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    project: string;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    category: string;
    constructor(configApp: IConfigApp, page: ISettingPage) {
        super(configApp);
        this.page = page;
        this.pageId = page.id;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getNode() {
        if (this.page.getNode) {
            return this.page.getNode();
        } else {
            return {
                type: this.page.type,
                title: this.page.title,
                id: this.page.id,
                icon: "admin/setting.png",
                children: <IDB[]>[],
            };
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    saveAsync() {
        if (this.page.saveAsync) {
            return this.page.saveAsync();
        }

        let res = $.Deferred();
        res.resolve(this.pageId);
        return res;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    load(pageId: string) {
        super.load(pageId);

        let that = this;
        this.project = that.getProject();
        this.category = that.getCategory();

        this.initPage(
            this.page.title + " - " + this.getProject(),
            !!this.page.advanced,
            this.page.del ? "Really?" : "",
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            this.page.help,
            this.page.externalHelp,
        );

        if (this.page.render) {
            this.page.render(this.simple);
        }
    }

    protected showAdvanced(): void {
        if (this.page.advanced) {
            this.page.advanced();
        }
    }

    protected doDelete(): void {
        if (this.page.del) {
            this.page.del();
        }
    }
}
